module.exports = __webpack_public_path__ + "assets/slack-brands.e5dbacb1.svg";